<app-dialog [dialogTitle]="'public.global.inActivityCus' | translate">
  <app-dialog-content>
    <div class="text-center">
      <p id="timeLeft" class="font-size-primary mb-2">
        0:{{ timeLeft }} (m:ss)
      </p>
      <progress max="45" [value]="timeLeft" class="w-100"></progress>
    </div>
  </app-dialog-content>
  <app-dialog-actions>
    <div class="d-sm-flex justify-content-end gap-3 w-100">
      <app-button
        variant="outline-dark"
        classes="px-4 mr-0 mr-sm-2 mb-3 mb-sm-0"
        (click)="onYesOrNoPress('START_NEW_ORDER')"
      >
        {{ 'public.global.inNewOrder' | translate }}
      </app-button>
      <app-button
        variant="dark"
        classes="px-2 px-sm-4"
        (click)="onYesOrNoPress('CLOSED')"
      >
        {{ 'public.global.inContinueOrder' | translate }}
      </app-button>
    </div>
  </app-dialog-actions>
</app-dialog>
